
export const LARGEUR_FLECHE = 20
export const DUREE_AFFICHAGE_BULLE = 3000
const MARGE_FLECHE = 12

export function positionFlecheSousActivateur (activateur, bulle) {
  if (activateur == null || bulle == null) {
    return null
  }

  const rectActivateur = activateur.getBoundingClientRect()
  const rectBulle = bulle.getBoundingClientRect()

  if (rectBulle.width === 0) {
    return null
  }

  const positionMax = rectBulle.width - MARGE_FLECHE - LARGEUR_FLECHE
  if (positionMax < MARGE_FLECHE) {
    return null
  }

  const centreActivateur = rectActivateur.left + rectActivateur.width / 2
  const positionIdeale = centreActivateur - rectBulle.left - LARGEUR_FLECHE / 2

  return Math.round(Math.min(Math.max(positionIdeale, MARGE_FLECHE), positionMax))
}

const NOMBRE_ESSAIS = 5

export function mesurerApresPlacement (composant, mesure) {
  let precedente = null
  let essaisRestants = NOMBRE_ESSAIS

  const essayer = () => {
    const valeur = mesure()
    essaisRestants -= 1

    if ((valeur != null && valeur === precedente) || essaisRestants <= 0) {
      return
    }

    precedente = valeur
    window.requestAnimationFrame(essayer)
  }

  composant.$nextTick(() => window.requestAnimationFrame(essayer))
}
